<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { general } from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";
import {clientHelpers} from "@/mixins/clientHelpers";

export default {
  name: 'WillResidentialPartnerYN',
  mixins: [clientHelpers, general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    clientData: {
      type: Object,
      required:  true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  `Are you planning to leave your ${
           this.clientData.assets.filter(
                        (a) =>
                            a.assetType ===
                            'Residential Home' &&
                            a.clients.length === 1
                    ).length
                ? ''
                : 'share of the'
        } residential property to your partner initially?`,
        subTitle:  `${
           this.clientData.assets.filter(
                        (a) =>
                            a.assetType ===
                            'Residential Home' &&
                            a.clients.length === 1
                    ).length
                ? 'This is typical where your partner is living with you in the property.'
                : 'As the property is jointly owned this is what tends to happy by default.'
        }`,
        tip: null,
      },
      db: {
        saveLocation: 'estate_planning_survey_save',
        saveField: 'will_distribution_residential_partner',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>